var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompaniesIconColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    fill: "none",
    viewBox: "0 0 6 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1c2238",
    d: "M5.8 2.4H3.6V.2a.2.2 0 0 0-.2-.2H.2a.2.2 0 0 0-.2.2v5.6c0 .11.09.2.2.2h5.6a.2.2 0 0 0 .2-.2V2.6a.2.2 0 0 0-.2-.2zM2.2 5.6h-.8V4.4h.8v1.2zm1-3v3h-.591V4H1.006v1.6H.4V.4h2.8v2.2zm2.4 3h-2V2.8h2v2.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c2238",
    d: "M1.603.783h-.41v.41h.41v-.41zM2.422.783h-.41v.41h.41v-.41zM1.603 1.602h-.41v.41h.41v-.41zM2.422 1.602h-.41v.41h.41v-.41zM1.603 2.385h-.41v.41h.41v-.41zM2.422 2.385h-.41v.41h.41v-.41zM4.398 3.205h-.41v.41h.41v-.41zM5.217 3.205h-.41v.41h.41v-.41zM4.398 3.988h-.41v.41h.41v-.41zM5.217 3.988h-.41v.41h.41v-.41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesIconColor);
export default __webpack_public_path__ + "static/media/companies_icon_color.6140fd2bb3821bb3f8e3964484703055.svg";
export { ForwardRef as ReactComponent };